import { render } from "./Sorting.vue?vue&type=template&id=2fb07735"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"

import "./Sorting.vue?vue&type=style&index=0&id=2fb07735&lang=scss"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__